import "../css/style.css"
import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import { Tabs } from "antd"
import Footer from "../components/footer"

const DocsAndTasksPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const onChange = (key) => {
        console.log(key);
    };
    const items = [
        {
            key: '1',
            label: `Offer documents`,
            children: <div>
                Please note that viewing offers in MyAya is currently only available to our early access users. Please continue to visit DocuSign to access your offers.
            </div>,
        },
        {
            key: '2',
            label: `Compliance items`,
            children: <div>
                <h1 className="font-bold">No acive travel contracts</h1>
                <p>When you have an active travel contract, the documents that must be completed for your assignment can be uploaded here.</p>
            </div>,
        },
    ];

    return (
        <Navbar active={"docsAndTasks"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-bold">Documents & tasks</h1>
            </div>
            <div className="relative top-14">
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} className="w-full pl-4" />
            </div>
            <div className="fixed bottom-0 w-full">
                <Footer />
            </div>
        </Navbar>
    )
}

export default DocsAndTasksPage